"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Trigger = exports.Popover = exports.consts = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var consts = {
  transition: "150ms"
};
exports.consts = consts;

var Popover = _styledComponents["default"].div.withConfig({
  displayName: "Popoverstyles__Popover",
  componentId: "sc-1lyt872-0"
})(["display:inline-block;"]);

exports.Popover = Popover;
var Trigger = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Popoverstyles__Trigger",
  componentId: "sc-1lyt872-1"
})(["&:focus{box-shadow:none;", ";}"], _stylers["default"].focusRing.subtle());
exports.Trigger = Trigger;
//# sourceMappingURL=Popover.styles.js.map